import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute, { FullLoader } from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import AdminOverview from "@/pages/admin/AdminOverview";
import Practitioners from "@/pages/admin/Practitioners";
import Hub from "@/pages/practitioner/Hub";
import History from "@/pages/practitioner/History";
import Profile from "@/pages/practitioner/Profile";
import Capture from "@/pages/reading/Capture";
import Reveal from "@/pages/reading/Reveal";
import ChooseMode from "@/pages/ChooseMode";
import PortalHome from "@/pages/portal/PortalHome";
import PortalIntro from "@/pages/portal/PortalIntro";
import Lore from "@/pages/Lore";
import { isPortalMode } from "@/lib/mode";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (isPortalMode()) return <Navigate to="/portal" replace />;
  return <Navigate to="/choose" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />

          {/* Admin */}
          <Route
            element={
              <ProtectedRoute role="admin">
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/admin" element={<AdminOverview />} />
            <Route path="/admin/practitioners" element={<Practitioners />} />
          </Route>

          {/* Practitioner */}
          <Route
            element={
              <ProtectedRoute role="practitioner">
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/practitioner" element={<Hub />} />
            <Route path="/practitioner/history" element={<History />} />
            <Route path="/practitioner/profile" element={<Profile />} />
          </Route>

          {/* Mode chooser + self-guided Palm Portal (full screen) */}
          <Route
            path="/choose"
            element={
              <ProtectedRoute role="practitioner">
                <ChooseMode />
              </ProtectedRoute>
            }
          />
          <Route
            path="/portal"
            element={
              <ProtectedRoute role="practitioner">
                <PortalIntro />
              </ProtectedRoute>
            }
          />
          <Route
            path="/portal/begin"
            element={
              <ProtectedRoute role="practitioner">
                <PortalHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lore"
            element={
              <ProtectedRoute role="practitioner">
                <Lore />
              </ProtectedRoute>
            }
          />

          {/* Reading ritual (full screen) */}
          <Route
            path="/reading/capture"
            element={
              <ProtectedRoute role="practitioner">
                <Capture />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reading/reveal"
            element={
              <ProtectedRoute role="practitioner">
                <Reveal />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
